import Page from "./Page";
import Events from "../Utils/EventLite";
import Template from "./Voting.ejs";
import Pumpkins from "../Utils/Pumpkins";
import Screen from "../Utils/Screen";
import VotingGame from "../Utils/VotingGame";
import VotingItem from "./Components/VotingItem";
import {CONFIG} from "../config";

export default class Voting extends Page {
    constructor() {
        super(Template, {}, "Voting");
        Screen.setAnchor("positionAlandscape", 0.3, 0.5);
        Screen.setAnchor("positionBlandscape", 0.7, 0.5);

        Screen.setAnchor("positionAportrait", 0.5, 0.35);
        Screen.setAnchor("positionBportrait", 0.5, 0.7);
        
    }

    bindEvents() {
        super.bindEvents();
        window.addEventListener("resize", Screen.resize);
    }

    unbindEvents() {
        super.unbindEvents();
        window.removeEventListener("resize", Screen.resize);
    }
    handleButton(e) {
        switch(e.currentTarget.getAttribute("data-action")) {
            case "vote":
                localStorage.setItem("vote"+CONFIG.year, this.voting.selected.data.key);
                ga('send', 'event',  'Final Vote', this.voting.selected.data.Name);
                if(!CONFIG.testing) {
                    this.voting.pumpkins.vote(this.voting.selected.data.key).then(()=>{
                        Events.trigger("goto", "StoryComplete");
                 });
                } else {
                    Events.trigger("goto", "StoryComplete");
                }
                break;
            case "restart":
            this.voting.resetGame();
                break;

        }
    }
    init(resolve, reject) {
        super.init(resolve, reject);

        this.pumpkins = new Pumpkins(CONFIG.year);
        this.pumpkins.get().then(function(values){

            Screen.recalculate();
            this.voting = new VotingGame(values, this.element, this.pumpkins);

            this.voting.nextRound();
        }.bind(this));
    }
}



// WEBPACK FOOTER //
// ./src/views/Voting.js